import { notification } from 'antd';
import { AppContext } from 'App.context';
import { act } from 'react';
import { useContext, useEffect, useState } from 'react';
import { ApiContext } from 'utils/networking/Api.context';

export default function usePoliceReportERTZConfigHook() {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    fileFormat: null,
    sesUser: null,
    sesPass: null,
    lessorCode: null,
    establishmentCode: null,
    suscription: null,
    sendSuscriptionRequestEnabled: true,
    awsKey: null,
    platform: null,
  });

  useEffect(() => {
    actions.loadPoliceReportConfig();
  }, [appState.selectedHotel]);

  // useEffect(() => {
  //   const fileName = actions.getFileName();
  //   if (fileName) {
  //     state.awsKey = fileName;
  //   }
  // }, []);

  const actions = {
    loadPoliceReportConfig: () => {
      updateState({ isLoading: true });
      API.getPoliceConfig({ hotelId: getSelectedHotel()?.key })
        .then(res => {
          updateState({
            isLoading: false,
            fileFormat: res?.fileFormat,
            sesUser: res?.sesUser,
            sesPass: res?.sesPass,
            lessorCode: res?.lessorCode,
            establishmentCode: res?.establishmentCode,
            suscription: res?.suscription === 'active',
            awsKey: res?.awsKey,
            platform: res?.platform,
          });
        })
        .catch(err => {
          console.warn(err);
          updateState({ isLoading: false });
        });
    },

    // TODO; COMPLETE CHECK CONNECTION FOR ERTZ PLATFFORM
    onCheckSESConnection: () => {
      updateState({ isLoading: true });
      API.policeReportCheckSESConnection({
        hotelId: getSelectedHotel()?.key,
        sesCredentials: {
          username: state.sesUser,
          password: state.sesPass,
          lessorCode: state.lessorCode,
          establishmentCode: state.establishmentCode,
        },
      })
        .then(result => {
          updateState({ isLoading: false });

          if (result.resultado) {
            notification.success({
              message: translate('policeReport.checkERTZConnectionSuccess'),
            });
          } else {
            const errorMessage =
              result?.respuesta?.error?.descripcion ||
              result?.respuesta?.error?.map(e => e.descripcion).join(' | ') ||
              translate('policeReport.checkERTZConnectionError');

            notification.error({
              message: errorMessage,
            });
          }
        })
        .catch(err => {
          console.warn(err);
          updateState({ isLoading: false });
          notification.error({
            message: translate('policeReport.checkERTZConnectionSuccess'),
          });
        });
    },

    uploadPfxFile: file => {
      updateState({ isLoading: true });

      API.uploadERTZFile({
        hotelId: getSelectedHotel()?.key,
        file: file,
      })
        .then(res => {
          updateState({
            isLoading: false,
            awsKey: res?.key,
          });
          notification.success({
            message: translate('policeReport.ertzFileSuccess'),
          });
        })
        .catch(error => {
          updateState({ isLoading: false });
          console.warn(error);
          notification.error({
            message: translate('policeReport.ertzFileError'),
          });
        });
    },

    onSaveERTZConfig: () => {
      updateState({ isLoading: true });

      API.updatePoliceERTZ({
        hotelId: getSelectedHotel()?.key,
        ertzCredentials: {
          platform: 'ertz',
          ertzCredentials: {
            user: state.sesUser,
            password: state.sesPass || null,
          },
          lessorCode: state.lessorCode,
          establishmentCode: state.establishmentCode,
        },
      })
        .then(res => {
          updateState({ isLoading: false });
          if (res.success) {
            notification.success({
              message: translate('policeReport.ertzSuccess'),
            });
          } else {
            notification.error({
              message: translate('policeReport.ertzError'),
            });
          }
        })

        // Esto a lo mismo se puede hacer verificando el pfx tipo si se desencripta pues usar eso ns
        // TODO: CHECK THE REQUEST TO CHECK THE CONNECTION
        // API.policeReportCheckSESConnection({
        //   hotelId: getSelectedHotel()?.key,
        //   sesCredentials: {
        //     username: state.sesUser,
        //     password: state.sesPass,
        //     lessorCode: state.lessorCode,
        //     establishmentCode: state.establishmentCode,
        //   },
        // })
        //   .then(result => {
        //     updateState({ isLoading: false });

        //     if (result.success) {
        //       notification.success({
        //         message: translate('policeReport.checkSESConnectionSuccess'),
        //       });
        //     } else {
        //       notification.error({
        //         message: translate('policeReport.checkSESConnectionError'),
        //       });
        //     }
        //   })
        //   .catch(err => {
        //     console.warn(err);
        //     updateState({ isLoading: false });
        //     notification.error({
        //       message: translate('policeReport.checkSESConnectionError'),
        //     });
        //   });
        .catch(err => {
          //ERROR saving credentials
          console.warn(err);
          updateState({ isLoading: false });
          notification.error({
            message: translate('policeReport.ertzError'),
          });
        });
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },

    getFileName: () => {
      if (state.awsKey) {
        return state.awsKey?.split('-')[1];
      }
    },

    deleteFile: () => {
      updateState({ isLoading: true });

      API.deletePoliceERTZFile({
        hotelId: getSelectedHotel()?.key,
      })
        .then(() => {
          updateState({
            isLoading: false,
            fileFormat: null,
            awsKey: null,
          });
          notification.success({
            message: translate('policeReport.ertzDeleteFileSuccess'),
          });
        })
        .catch(error => {
          updateState({ isLoading: false });
          console.error(error);
          notification.error({
            message: translate('policeReport.ertzDeleteFileError'),
          });
        });
    },
    isAdmin: () => {
      return appState?.superUser ? true : false;
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
